import { useEffect } from "react";

import { OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../useOrderFormik";

const useUpdateCountryNames = (): void => {
  const {
    values: {
      [OrderFields.STARTING_COUNTRY]: startingCountryCode,
      [OrderFields.DESTINATION_COUNTRY]: destinationCountryCode,
    },
    setFieldValue,
  } = useOrderFormik();

  const {
    staticData: { countriesFrom },
    dynamicData: { countriesTo },
  } = useOrderData();

  useEffect(() => {
    const startingCountry = countriesFrom.find(({ code }) => code === startingCountryCode);
    setFieldValue(OrderFields.STARTING_COUNTRY_NAME, startingCountry?.title || "");
  }, [startingCountryCode, countriesFrom, setFieldValue]);
  useEffect(() => {
    const destinationCountry = countriesTo.find(({ code }) => code === destinationCountryCode);
    setFieldValue(OrderFields.DESTINATION_COUNTRY_NAME, destinationCountry?.title || "");
  }, [destinationCountryCode, countriesTo, setFieldValue]);
};
export default useUpdateCountryNames;
